import { Controller } from '@hotwired/stimulus'

// Folhas inferiores (<dialog class="folha">): abrir por id, fechar a folha
// atual, fechar clicando no fundo. Dialog com data-folha-abrir abre sozinho.
export default class extends Controller {
  connect() {
    this.element.querySelectorAll('dialog.folha[data-folha-abrir]').forEach((d) => this.show(d))
    this.onClick = (e) => { if (e.target.matches?.('dialog.folha')) e.target.close() }
    this.element.addEventListener('click', this.onClick)
  }

  disconnect() { this.element.removeEventListener('click', this.onClick) }

  abrir(event) {
    event.preventDefault()
    const dialog = document.getElementById(event.params.id)
    if (dialog) this.show(dialog)
  }

  fechar(event) {
    event.currentTarget.closest('dialog')?.close()
  }

  show(dialog) {
    if (dialog.open) return
    if (typeof dialog.showModal === 'function') dialog.showModal()
    else dialog.setAttribute('open', '')
    dialog.querySelector('[data-folha-foco]')?.focus()
  }
}
